import { customAlphabet } from "nanoid";
/** URL-safe, no lookalike-hostile characters needed — these are never typed by hand. */
const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
const nanoFieldId = customAlphabet(ALPHABET, 12);
const nanoChoiceId = customAlphabet(ALPHABET, 8);
const nanoSlug = customAlphabet("0123456789abcdefghijklmnopqrstuvwxyz", 10);
/**
 * Field ids are minted here and NEVER reused. Deleting a field and adding it
 * back yields a new id; changing a field's type to one that cannot hold the old
 * answers also yields a new id (see `isLosslessTypeChange`). That rule is what
 * keeps historical responses renderable.
 */
export const newFieldId = () => nanoFieldId();
export const newChoiceId = () => nanoChoiceId();
/** Public form slug: `/r/{slug}`. Assigned once, at first publish, never reused. */
export const newSlug = () => nanoSlug();
//# sourceMappingURL=ids.js.map